<!--
 * @Author: Shber
 * @Date: 2023-05-06 09:51:05
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-11 19:04:23
 * @Description:
-->
<template>
  <div :class="{'text_show':textShow, 'Logo':true}" :style="'background:'+ color +''">
    <p v-if="textShow" class="fw_bold">联合出品</p>
    <div class="img_box">
      <img src="https://static.mingchu.co/webapp/xintan/bottom_logo.png" alt="">
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue'
export default {
  name: 'Home',
  props: {
    color: {
      type: String,
      default: '#FAF5E6'
    },
    textShow: { // 是否展示文字
      type: Boolean,
      default: true
    }
  },
  setup() {
    const state = reactive({
    })
    return { ...toRefs(state) }
  }
}
</script>
<style lang="scss">
.text_show{
  padding-top: 75px !important;
}
.Logo{width: 100%; padding-bottom: 60px;  padding-top: 32px;
  .img_box{display: flex; justify-content: center;}
    p{font-size: 16px; line-height: 22px; color: #333333; text-align: center;}
    img{ width:159px; height: 56px; padding-top: 15px;}
  }
</style>

